import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { HiOutlineDocumentText } from 'react-icons/hi2';

const sections = [
  { id: 'agreement', title: '1. Binding Agreement' },
  { id: 'account', title: '2. Registration & Account' },
  { id: 'services', title: '3. Service Usage & Charges' },
  { id: 'intellectual', title: '4. Intellectual Property' },
  { id: 'refunds-overview', title: '5. Refunds & Claims' },
  { id: 'force-majeure', title: '6. Force Majeure' },
  { id: 'jurisdiction', title: '7. Law & Jurisdiction' },
];

const TermsAndConditions = () => {
  return (
    <LegalLayout
      title="Terms & Conditions"
      subtitle="Please read these terms and conditions carefully before using the Falhari website or subscribing to our fruit services."
      lastUpdated="October 09, 2026"
      sections={sections}
    >
      <div className="space-y-8 text-gray-700">
        
        {/* Intro Note */}
        <div className="p-4 rounded-lg bg-orange-50/60 border border-orange-200/60 flex items-start gap-3">
          <HiOutlineDocumentText className="text-xl text-[#FF410B] shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-normal">
            These Terms & Conditions constitute a legally binding agreement between <span className="font-semibold text-gray-900">Feastic Services Pvt Ltd</span> (“Falhari”, “Website Owner”, “we”, “us”, or “our”) and you (“you” or “your”), relating to your use of our website, fresh fruit products, corporate plans, and delivery services.
          </p>
        </div>

        {/* Section 1 */}
        <section id="agreement" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">1. Binding Agreement & Modifications</h2>
          <p className="text-sm leading-relaxed text-gray-700">
            By accessing or using our website and availing of our services, you confirm that you have read, understood, and accepted these Terms (including our Privacy Policy, Refund Policy, and Cancellation Policy). We reserve the right to update or modify these Terms at any time without prior individual notice. Continued use of our website or services constitutes acceptance of all revised terms.
          </p>
        </section>

        {/* Section 2 */}
        <section id="account" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">2. Account Registration & Obligations</h2>
          <p className="text-sm leading-relaxed text-gray-700 mb-2">
            To access and use our ordering or subscription services, you agree to:
          </p>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
            <li>Provide accurate, current, and complete personal and delivery details during registration.</li>
            <li>Maintain the security of your account credentials and accept full responsibility for all activities conducted through your account.</li>
            <li>Notify us immediately of any unauthorized access or security breaches concerning your account.</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section id="services" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">3. Service Usage, Pricing & Transactions</h2>
          <p className="text-sm leading-relaxed text-gray-700 mb-2">
            When placing an order or subscribing to daily/weekly fruit salads and fresh juices:
          </p>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
            <li>You agree to pay the published charges associated with the products or services selected, including applicable taxes and delivery fees.</li>
            <li>All pricing is subject to change based on seasonal availability and market conditions. Price modifications will not affect orders already confirmed.</li>
            <li>Initiating a transaction constitutes a legally binding and enforceable contract between you and Feastic Services Pvt Ltd.</li>
            <li>You agree not to use our website or services for any unlawful, illegal, or prohibited purposes under Indian law.</li>
          </ul>
        </section>

        {/* Section 4 */}
        <section id="intellectual" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">4. Intellectual Property Rights</h2>
          <p className="text-sm leading-relaxed text-gray-700">
            All brand elements, logos, graphics, brand slogans (“Think Fruits #GoFalhari”), website content, UI designs, and proprietary recipes are the exclusive intellectual property of <span className="font-semibold text-gray-900">Feastic Services Pvt Ltd</span>. Unauthorized reproduction, modification, or commercial distribution is strictly prohibited.
          </p>
        </section>

        {/* Section 5 */}
        <section id="refunds-overview" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">5. Refunds & Claims Overview</h2>
          <p className="text-sm leading-relaxed text-gray-700">
            You are entitled to claim a refund in cases where we are unable to fulfill your order or deliver damaged/defective produce, strictly according to the timelines and criteria outlined in our <a href="/refund-policy" className="text-[#FF410B] font-semibold underline">Refund Policy</a>. Claims submitted outside the specified window will not be eligible.
          </p>
        </section>

        {/* Section 6 */}
        <section id="force-majeure" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">6. Force Majeure</h2>
          <p className="text-sm leading-relaxed text-gray-700">
            Neither party shall be held liable for failure or delay in performing contractual obligations if caused by events beyond reasonable control, including natural disasters, extreme weather conditions, government restrictions, severe traffic disruptions, or widespread civil emergencies.
          </p>
        </section>

        {/* Section 7 */}
        <section id="jurisdiction" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">7. Governing Law & Legal Jurisdiction</h2>
          <p className="text-sm leading-relaxed text-gray-700">
            These Terms & Conditions and any disputes arising out of or in connection with them shall be governed by and construed in accordance with the laws of India. All legal claims or proceedings shall be subject to the exclusive jurisdiction of the courts located in <span className="font-semibold text-gray-900">Gurugram / Gurgaon, Haryana, India</span>.
          </p>
        </section>

      </div>
    </LegalLayout>
  );
};

export default TermsAndConditions;
